module.exports = __webpack_public_path__ + "static/subscribe-61b7ba3439be6bd25db7be186cf91d75.jpg";